import type { Point, SpatialRectangle } from "#public"

/** The middle of a box. */
export const Center = <T extends number>({
  x,
  y,
  width,
  height,
}: SpatialRectangle<T>): Point<T> => ({
  x: (x + width / 2) as T,
  y: (y + height / 2) as T,
})
